import styled from "styled-components";

const ReceivedMessage = styled.div`
  max-height: 300px;
  overflow: auto;
`;

export default ReceivedMessage;
